/**
 * Copy for the Location Pill and the Select Location pop-up (TEAM-13315). Kept as
 * constants rather than CMS string keys: brand strings fetched from the
 * Configurations API replace the fallback file wholesale, so a key added only
 * here would render blank for every brand.
 */
export const LOCATION_PILL_COPY = {
  pickupEyebrow: 'Pickup from',
  deliveryEyebrow: 'Delivered from',
  deliveryTo: 'to',
  changeLocationLabel: (current: string) => `Change location, currently ${current}`,
  modalTitle: 'Select Location',
  current: 'Current',
  loading: 'Loading locations…',
  loadError: "We couldn't load this restaurant's locations.",
  retry: 'Try again',
  unavailable: 'Not available for this order',
} as const;
